import {ChangeDetectionStrategy, Component, input, Input, output} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormArray} from "@angular/forms";
import {MedlemImporterSkjemalinjeType} from "../medlem-importer-skjemalinje/medlem-importer-skjemalinje";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";

const debug = initDebugger('MedlemImporterSkjemaoverskrifterKomponent');


@Component({
    selector: 'medlem-importer-skjemaoverskrifter',
    templateUrl: './medlem-importer-skjemaoverskrifter.html',
    styleUrl: './medlem-importer-skjemaoverskrifter.scss',
    imports: [
        MatCheckbox,
        MatTooltip,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemImporterSkjemaoverskrifterKomponent {

  @Input({required:true}) skjema!: FormArray<MedlemImporterSkjemalinjeType>;

    alleValgt = input.required<boolean>();
    ingenValgt = input.required<boolean>();

    endreAlle = output<void>();

    constructor() {
    }

}
